// Placeholder badge -- colored circle + state code. Not a real state
// flag/seal asset; swap in proper artwork before this ships broadly, same
// caveat as ProviderBadge.
interface StateBadgeProps {
  state: string;
  size?: "sm" | "lg";
}

export function StateBadge({ state, size = "sm" }: StateBadgeProps) {
  const dimension = size === "lg" ? "w-12 h-12 text-sm" : "w-8 h-8 text-xs";

  return (
    <div
      className={`${dimension} flex items-center justify-center rounded-full bg-gray-200 text-gray-700 font-semibold flex-shrink-0`}
      aria-hidden="true"
    >
      {state}
    </div>
  );
}
